import TelescopeV2Icon from './component.jsx'
export default TelescopeV2Icon
